import React from "react"

export const PlayerPlay = props => (
  <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.1859 8.13557C15.8474 8.52145 15.8474 9.47725 15.1859 9.86313L2.17056 17.4554C1.5039 17.8443 0.666687 17.3634 0.666687 16.5916V1.40705C0.666687 0.63526 1.5039 0.154391 2.17056 0.543274L15.1859 8.13557Z" fill="currentColor"/>
  </svg>
)
